import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";



const FeatureBox = styled(Box)(({ theme }) => ({
    padding: "16px",
    paddingLeft: "32px",
    paddingRight: "32px",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "50%",
      width: "4px",
      height: "50%",
      transform: "translateY(-50%)",
      background: 'linear-gradient(90deg, #9c27b0 0%, #6a1b9a 100%)',
      borderRadius: "2px"
    }
}));

const features = [
    {
        title: "No Per-User Pricing",
        description: "Pay one price for unlimited team members. Scale your team without scaling costs."
    },
    {
        title: "Full Platform Access",
        description: "Get access to all features and future updates. No feature gates or restrictions."
    },
    {
        title: "Support Included",
        description: "Expert support available no matter your plan. Get help when you need it."
    },
    {
        title: "Scalable Infrastructure",
        description: "Built to grow with you. No hidden costs or surprise fees as you scale."
    }
];

export default () => {
    return (
        <Box component="section" aria-label="pricing section" sx={{ position: "relative", overflow: "hidden" }}>
            <Box textAlign="center" sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#3b0e59', justifyContent: "center", minHeight: "12vh" }}>
                <Typography fontFamily="Red Rose" fontSize="24px" color="#fff" paddingTop="12px" paddingLeft="40px" paddingRight="40px" sx={{
                    '@media (max-width: 600px)': {
                        fontSize: '20px',
                    },
                }}>
                    Grow At Your Own Pace
                </Typography>
                <Typography fontFamily="Raleway" fontSize="20px" color="#f8faf9" paddingBottom="12px" paddingLeft="40px" paddingRight="40px" sx={{
                    '@media (max-width: 600px)': {
                        fontSize: '16px',
                    },
                }}>
                    Break free from per-user pricing. One flat rate for unlimited team growth. Future-proof your scaling strategy today.
                </Typography>
            </Box>

            <Container maxWidth="lg">
                <Grid container spacing={1} sx={{ mt: 2 }} rowGap={1}>
                    {features.map((feature, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <FeatureBox>
                                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
                                    <Box>
                                        <Typography variant="h5" fontFamily="Red Rose" sx={{ 
                                            fontWeight: 700, 
                                            color: "#6a1b9a",
                                            '@media (max-width: 600px)': {
                                                fontSize: '24px',
                                            },
                                        }}>{feature.title}</Typography>
                                        <Typography fontFamily="Raleway" color="#212529" fontSize="18px" sx={{
                                            '@media (max-width: 600px)': {
                                                fontSize: '16px',
                                            },
                                        }}>{feature.description}</Typography>
                                    </Box>
                                </Box>
                            </FeatureBox>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};